import * as Dialog from "@radix-ui/react-dialog";
import styled, { keyframes } from "styled-components";

const overlayShow = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const overlayHide = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const contentShow = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

const contentHide = keyframes`
  from { transform: translateY(0); }
  to { transform: translateY(100%); }
`;

export const Root = Dialog.Root;
export const Trigger = Dialog.Trigger;
export const Portal = Dialog.Portal;

export const Overlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  background-color: #00000080;

  animation: ${overlayShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);

  &[data-state="closed"] {
    animation: ${overlayHide} 400ms cubic-bezier(0.3, 1, 0.16, 1);
  }
`;

export const Content = styled(Dialog.Content)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: #ffffff;

  display: flex;
  flex-direction: column;
  border-radius: 10px 10px 0 0;
  padding: 1rem 2rem;

  animation: ${contentShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);

  &[data-state="closed"] {
    animation: ${contentHide} 400ms cubic-bezier(0.3, 1, 0.16, 1);
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: "";
    position: absolute;
    top: 1rem;
    left: calc(50% - 2.5rem);

    width: 5rem;
    height: 0.5rem;
    border-radius: 8px;

    background-color: #a7a3a3b0;
  }
`;

export const Title = styled(Dialog.Title)`
  text-align: center;
`;

export const InstructionsList = styled.ol`
  list-style: none;
  counter-reset: instructions-counter;
  padding: 0;

  li {
    counter-increment: instructions-counter;
    margin-bottom: 1rem;
    padding-left: 1rem;
    color: #555555;

    &::before {
      content: counter(instructions-counter);
      display: inline-flex;
      justify-content: center;
      align-items: center;

      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      margin-right: 1rem;

      color: #30c0bb;
      border: 2px solid #30c0bb;

      text-align: center;
    }
  }
`;
